import { withTranslation } from "next-i18next";
import { useState, useEffect } from "react";
import Image from "@components/core/Image";
import LowResultsProductSlider from "@components/views/Catalog/LowResultsSection/LowResultsProductSlider";
import isServer from "@utils/is-server";
import { getProducts } from "@utils/call-api/products-call";
import catalogContexts from "@utils/constants/catalogContexts";

function UserListNotFound({ t }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function getNewestProducts() {
      try {
        const queryString = "order_by[]=newest";
        const res = await getProducts(catalogContexts.swap, queryString);

        setProducts(res.data);
      } catch (err) {
        setProducts([]);
      }
    }

    getNewestProducts();
  }, []);

  if (isServer()) return null;

  return (
    <div>
      <div className="d-flex flex-column align-items-center px-3 py-6">
        <div
          style={{ width: "120px" }}
          className="pb-4 mb-2"
        >
          <Image
            src="handbagSadRetro"
            alt={t("catalog:userlist.not_found.alt")}
            className="w-100"
          />
        </div>
        <h3 className="mb-2 text-center">{t("catalog:userlist.not_found.title")}</h3>
        <p className="text-center mb-0 text-gray">{t("catalog:userlist.not_found.subtitle")}</p>
      </div>

      <div>
        <LowResultsProductSlider
          context={catalogContexts.userlist}
          products={products}
          uiState={{}}
        />
      </div>
    </div>
  );
}

export default withTranslation("catalog")(UserListNotFound);
